import React from 'react'
import PropTypes from 'prop-types'
import { Card, CardContent, Typography, Box, Button, Grid } from '@mui/material'
import { useDrop } from 'react-dnd'
import OrderCard from './OrderCard'
import { useTranslation } from 'react-i18next'
import './Planning.scss'
// Drag and Drop item types
const ItemTypes = {
  ORDER: 'order',
}
const DriverCard = ({ driver, transporterColor, moveOrder, toggleDriverStatus, isDragDisabled }) => {
  const { t } = useTranslation('planning_page')
  const [{ canDrop }, drop] = useDrop({
    accept: ItemTypes.ORDER,
    drop: (item) => {
      if (!driver.isOutOfOfficeToday) {
        moveOrder(item, driver.id, item.fromDriverId || null)
      }
    },
    canDrop: () => !driver.isOutOfOfficeToday,
    collect: (monitor) => ({
      canDrop: monitor.canDrop(),
    }),
  })

  return (
    <Card
      ref={drop}
      sx={{
        margin: '0 8px',
        borderLeft: !driver.isOutOfOfficeToday ? `8px solid ${transporterColor}` : '8px solid gray',
        width: 350,
        backgroundColor: !driver.isOutOfOfficeToday ? 'white' : 'lightgray',
        opacity: !driver.isOutOfOfficeToday ? 1 : 0.6,
        maxHeight: '620px',
        minWidth: '270px',
        overflow: 'auto',
        ...(canDrop ? { outline: '2px dashed #b0b0b0', outlineOffset: -2 } : {}),
      }}
    >
      <CardContent>
        <Grid container alignItems="center" spacing={2}>
          <Grid item xs={12} sm={7}>
            <Typography
              className="bold"
              variant="h5"
              sx={{
                wordBreak: 'break-word',
                whiteSpace: 'normal',
              }}
            >
              {driver.firstname + ' ' + driver.lastname}
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: 12 }}>
              {driver.transporter.name}
            </Typography>
          </Grid>

          <Grid item xs={12} sm={5} container justifyContent="flex-end">
            <Button
              variant="outlined"
              size="small"
              onClick={() => toggleDriverStatus(driver.id)}
              sx={{
                width: '100%',
                marginTop: { xs: '8px', sm: 0 },
              }}
              disabled={isDragDisabled}
            >
              {!driver.isOutOfOfficeToday ? t('markOutOfOffice') : t('markPresent')}
            </Button>
          </Grid>
        </Grid>
        {!driver.isOutOfOfficeToday ? (
          driver.orderDeliveries.edges.length > 0 ? (
            <Box overflow="auto">
              {driver.orderDeliveries.edges.map((order) => (
                <OrderCard
                  key={order.node.id}
                  deliveryOrder={order.node}
                  fromDriverId={driver.id}
                  isDragDisabled={isDragDisabled}
                />
              ))}
            </Box>
          ) : (
            <Card style={{ marginTop: '20px', backgroundColor: 'lightgray' }}>
              <Typography style={{ margin: '5px' }} variant="body1">
                {t('noOrderYet')}
              </Typography>
            </Card>
          )
        ) : (
          <Card style={{ marginTop: '20px', backgroundColor: 'white' }}>
            <Typography style={{ margin: '5px' }} variant="body1">
              {t('markOutOfOffice')}
            </Typography>
          </Card>
        )}
      </CardContent>
    </Card>
  )
}

DriverCard.propTypes = {
  driver: PropTypes.any.isRequired,
  isDragDisabled:PropTypes.bool,
  transporterColor: PropTypes.string.isRequired,
  moveOrder: PropTypes.func.isRequired,
  toggleDriverStatus: PropTypes.func.isRequired,
}

export default DriverCard
